import styled from "styled-components"; 
import React, { useState } from "react"; 
import { LuArrowUp } from "react-icons/lu";
  
export const Heading = styled.h1` 
  text-align: center; 
`; 
  
export const Content = styled.div` 
  overflow-y: scroll; 
  height: 2500px; 
`; 
  
export const Button = styled.div` 
  position: fixed;  
  width: 100%; 
  left: ${({ visible }) => visible ? "85%" : "100%"};
  bottom: 40px; 
  height: 20px; 
  font-size: 3rem; 
  z-index: 1; 
  cursor: pointer; 
  transition: 200ms;
`

export function ScrollButton() {
  const [visible, setVisible] = useState(false) 
  
  const toggleVisible = () => { 
    const scrolled = document.documentElement.scrollTop; 
    if (scrolled > 300){ 
      setVisible(true) 
    }  
    else if (scrolled <= 300){ 
      setVisible(false) 
    } 
  }; 
  
  const scrollToTop = () =>{ 
    window.scrollTo({ 
      top: 0,  
      behavior: 'smooth'
    }); 
  }; 
  
  window.addEventListener('scroll', toggleVisible); 
  
  return ( 
    <Button visible={visible}> 
     <LuArrowUp onClick={scrollToTop} />
    </Button> 
  ); 
}